import { logout as _logout, getToken } from 'grab-login/lib/helper';
import Storage from 'grab-storage';
import { logoutAction } from 'actions/login-actions';
import fetchUtil from 'common/utils/fetch';
import {
  clearAuthResponses,
  clearGrabIdTokens,
} from 'helper/grab-id-auth-helper';
import endpoints from 'actions/login-endpoints';
import { isDev } from 'common/utils/environment-util';
import { APP_BASE_URL_PATH } from 'constants/app-constants';
import { ROUTES_V2_PATHS } from 'constants/route-constants';

export const AUTH_HINT = '__AUTH_HINT__';
export const AUTH_HINT_LOCAL = 'LOCAL';
export const AUTH_HINT_COOKIE = 'COOKIE';
export const TOKEN_NAME = '__TOKEN__';

export const getAuthHint = () => Storage.getItem(AUTH_HINT);

export const isAuthHintLocal = () => getAuthHint() === AUTH_HINT_LOCAL;

export const isAuthHintCookie = () => getAuthHint() === AUTH_HINT_COOKIE;

export const isAuthHintEmpty = () => !getAuthHint();

export const setAuthHintCookie = () => {
  Storage.setItem(AUTH_HINT, AUTH_HINT_COOKIE);
};

export const setAuthHintLocal = () => {
  Storage.setItem(AUTH_HINT, AUTH_HINT_LOCAL);
};

export const clearAuthHint = () => {
  Storage.removeItem(AUTH_HINT);
};

export const clearLoginStorage = () => {
  clearAuthHint();
  clearAuthResponses();
  clearGrabIdTokens();
};

const GFBlogoutAction = () =>
  fetchUtil(endpoints.getGFBLogoutEpt(), {
    method: 'POST',
    credentials: 'include',
  });

export const sessionLogout = () => {
  clearLoginStorage();
  if (isAuthHintCookie()) {
    GFBlogoutAction().catch(err => {
      // eslint-disable-next-line no-console
      console.log('[GFBlogoutAction] log out fail', err);
    });
  } else {
    _logout();
    logoutAction({ token: getToken() });
  }
};

export const verifyGFBSession = () =>
  fetchUtil(endpoints.getGFBUserEpt(), {
    method: 'GET',
    credentials: 'include',
  });

export const getLoginRedirectUrl = () => {
  const {
    uri,
    endpoints: { grabIdLoginBaseUri, expressHomeBaseUri },
  } = window.Grab.config;

  const redirectRoute = isDev()
    ? `${uri}${ROUTES_V2_PATHS.gfbLoginSuccessRedirect}`
    : `${expressHomeBaseUri}${APP_BASE_URL_PATH}${
        ROUTES_V2_PATHS.gfbLoginSuccessRedirect
      }`;

  // NOTE: in Dev env, you have to update redirect to a stg path (redirect: 'https://express.stg-myteksi.com')
  // then manually visit ge-web-booking.grab.dev. else, the login on grab-id login page will fail due to different source
  return `${grabIdLoginBaseUri}/enterprise/login?${new URLSearchParams({
    redirect: redirectRoute,
    service_id: 'ENTERPRISE',
  })}`;
};

export const getUpdatePasswordRedirectUrl = () => {
  const {
    endpoints: { grabIdLoginBaseUri, expressHomeBaseUri },
  } = window.Grab.config;

  // NOTE: in Dev env, you have to update redirect to a stg path (redirect: 'https://express.stg-myteksi.com')
  // then manually visit ge-web-booking.grab.dev. else, the login on grab-id login page will fail due to different source
  return `${grabIdLoginBaseUri}/enterprise/change-password?${new URLSearchParams(
    {
      redirect: `${expressHomeBaseUri}${APP_BASE_URL_PATH}`,
      service_id: 'ENTERPRISE',
    },
  )}`;
};

export const buildCredentials = (isPax = false) =>
  !isPax && isAuthHintCookie() ? 'include' : 'omit';

export default {};
